import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

class AutomatedOverriddingRiskFactorForm extends Component {
    render() {
        return (
            <form autoComplete="on">
                <div className="row form-group">
                    <div className="col-sm-4">
                        <label>Risk Factor Name</label>
                    </div>
                    <div className="col-sm-10">
                        <Field type="text"
                            className="form-control"
                            component="input"
                            name="overriddingRiskFactorName"
                            id="overriddingRiskFactorName"
                            validate={[required]}
                            placeholder="Name of Risk Factor"
                        />
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-sm-4">
                        <label>Score</label>
                    </div>
                    <div className="col-sm-10">
                        <Field type="number"
                            className="form-control"
                            component="input"
                            name="overriddingScore"
                            id="overriddingScore"
                            validate={[required]}
                            placeholder="Score"
                        />
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-sm-4">
                        <label>Risk Factors</label>
                    </div>
                    <div className="col-sm-10">
                        <Field type="text"
                            className="form-control"
                            component="input"
                            name="overriddingFactors"
                            id="overriddingFactors"
                            validate={[required]}
                            placeholder="Risk Factors(Master Keys)"
                        />
                    </div>
                </div>
                <div className="row form-group">
                    <div className="col-sm-4">
                        <label>Risk Factor Rule</label>
                    </div>
                    <div className="col-sm-10">
                        <Field type="text"
                            className="form-control"
                            component="input"
                            name="overriddingRule"
                            id="overriddingRule"
                            validate={[required]}
                            placeholder="Formula"
                        />
                    </div>
                </div>
            </form>
        )
    }
}

const required = value => value ? undefined : 'Required';
AutomatedOverriddingRiskFactorForm = reduxForm({
    form: 'automatedOverriddingForm',
    enableReinitialize: true
})(AutomatedOverriddingRiskFactorForm)

const mapStateToProps = (state, ownProps) => ({
});

const mapDispatchToProps = (dispatch, ownProps) => ({
});
export default AutomatedOverriddingRiskFactorForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(AutomatedOverriddingRiskFactorForm)
